import { computeFileMD5 } from "@/shared/utils/file";
import { generateCommentAttachmentUploadUrl } from "@/spz-api/control-result-comments/control-result-comments";
import type { GenerateCommentAttachmentUploadUrlRequestDtoContentType } from "@/spz-api/model";
import axios from "axios";
import type { IAttachmentRepository } from "../interfaces/attachment.interface";

export class AttachmentRepository implements IAttachmentRepository {
  async uploadAttachment(
    controlId: string,
    resultId: string,
    file: File,
  ): Promise<string> {
    const md5Hash = await computeFileMD5(file);
    const contentType =
      file.type as GenerateCommentAttachmentUploadUrlRequestDtoContentType;

    const signedUrlResponse = await generateCommentAttachmentUploadUrl(
      controlId,
      resultId,
      {
        md5Hash,
        contentType,
        fileName: encodeURIComponent(file.name),
        fileSize: file.size,
      },
    );

    const { uploadUrl, id } = signedUrlResponse;

    const base64Md5Hash = await computeFileMD5(file, "base64");

    await axios.put(uploadUrl, file, {
      headers: {
        "Content-MD5": base64Md5Hash,
        "Content-Type": file.type || "application/octet-stream",
        "x-goog-meta-original-filename": encodeURIComponent(file.name),
      },
    });

    return id;
  }
}
